import { ab, showNote } from "../Exam";
import { answers, inputResult, times } from "../Submit/SaveAnswer";
import { transformSfToResult } from "./transformSf";

export var submissionDate:Date = new Date();
export var totalPoints = 0;
export var totalPossible = 0;
export var note = 5;

export function showPrint(){

    handleItems();

    handleTasks();

    changeFormForPrint();

    MathJax.typeset();
}

function changeFormForPrint(){
    const wrapper = $("#ab-form > .form-wrapper");
    $("#ab-form > .form-wrapper > .top").remove();
    $(".top-hr").remove();
    wrapper.removeClass("form-wrapper").addClass("all-tasks-wrapper");
    $(".tab").show();
    $("#ab-form").prepend(addHeadline(getAbName(), getAbPoints()))
}

export function getAbName(){
    return $("#ab-form").attr('data-name')
}

export function getAbPoints(){
    let points = 0;
    $(".tab").each((ind, obj) => {
        points += Number($(obj).attr('data-punkte'))
    })
    return points;
}

function addHeadline(headline:string, totalPoints:string){
    const html = '<div class="form-wrapper d-flex b-f align-items-center" style="padding-bottom: 1rem;"><h3 class="mb-0">' + headline + '</h3><div class="ms-auto">Insgesamt: ' + totalPoints +' Punkte</div></div>';
    return html;
}

function handleItems(){
    
}

function handleTasks(){
    $(".tab").each((ind, obj) => {
        const tab = $(obj);
        const html = tab.html();
        const newHtml = '<div class="form-wrapper">' + html + '</div>'
        tab.html(newHtml);
    })
}

// function handleItems(input:JQuery, taskId:number, inputId:number, results:inputResult){
//     let inputPoints = results.points;
//     let inputPossilbe = results.possible;

//     let type = input.attr('data-type');
    
//     switch(type){
//         case "if":
//             transformIfToResult(input, results, inputPoints, inputPossilbe)
//         break;
//         case "mc":
//             transformMcToResult(input, results, inputPoints, inputPossilbe)
//         break;
//         case "sc":
//             transformScToResult(input, results, inputPoints, inputPossilbe)
//         break;
//         case "sf":
//             transformSfToResult(input, results, inputPoints, inputPossilbe);
//         break;
//         case "ft":
//             transformFtToResult(input, results, inputPoints, inputPossilbe);
//         break;
//     }


// }
